import styled from "@emotion/styled";
export const StyledTemplateFeatureContent = styled.div`
  width: 100%;
  max-width: 720px;

  .demo-component-wrapper {
    margin-top: 48px;
  }
`;
